import { p_EnumToSelectOptions } from '@/utils/publicConfig'
import { getBaseCarModelEnum } from '@/api/publicAxios/publicAxios'
// 记录公共枚举字段
/**
 * 车新旧分类枚举 @ CarOldNewCategoryEnum
 * 启用状态  StatusEnum
 * 提车方式  OrderTakeCarMethodEnum
 * 还车方式  OrderReturnCarMethodEnum
 */

// 公共枚举方法，将数据转换为选择器选项
export const e_SelectEnum = async (enumStr: string) => {
  const res = await p_EnumToSelectOptions(enumStr)
  // 检查属性是否存在
  if (res && typeof res === 'object' && enumStr in res) {
    return res[enumStr]
  }

  console.warn(`Property ${enumStr} not found in response`)
  return [] // 或者返回适当的默认值
}

// 标准车型库特殊处理枚举数据
export const p_CarBaseModelEnum = async (str) => {
  try {
    const res = await getBaseCarModelEnum(str)

    if (res.code === 0 && Array.isArray(res.data)) {
      // 直接返回转换后的数组，不需要中间变量
      return res.data
        .filter((item) => item) // 过滤掉 falsy 值
        .map((item) => ({
          label: item,
          value: item
        }))
    }

    // 如果 code 不为 0 或 data 不是数组，返回空数组
    return []
  } catch (error) {
    console.error('获取基础车型枚举数据失败:', error)
    return []
  }
}
